const INTV_MENU_ITEMS = [
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-als",
        "label": "ALS",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-amputation",
        "label": "Manage amputation",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-bls",
        "label": "BLS",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "heading",
        "id": "heading-crico",
        "label": "Cricothyrotomy",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "heading",
        "id": "heading-establish-patency",
        "label": "Establish patency",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "heading",
        "id": "heading-insert-adjunct",
        "label": "Insert adjunct",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "heading",
        "id": "heading-intubation",
        "label": "Intubation",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-manage-internal-bleeding",
        "label": "Manage suspected internal bleeding",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-manage-shock",
        "label": "Manage hemorrhagic shock",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 3,
        "type": "heading",
        "id": "heading-medication-facilitated-intubation",
        "label": "Medication Facilitated Intubation",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "heading",
        "id": "heading-open-airway",
        "label": "Open airway",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "heading",
        "id": "heading-remove-foreign-body-obstructions",
        "label": "Remove foreign body obstructions",
        intvCategoryID: "intv-cat-airway"
    },
    {
         "depth": 1,
         "type": "heading",
         "id": "heading-severe-external-bleeding",
         "label": "Manage severe external bleeding",
         intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-transfer",
        "label": "Transfer patient to EMS vehicle",
        intvCategoryID: "intv-cat-extrication-and-transport"
    },
    {
        "depth": 1,
        "type": "heading",
        "id": "heading-transport",
        "label": "Transport to care facility",
        intvCategoryID: "intv-cat-extrication-and-transport"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-advanced-airway-adjunct",
        interventionID: "intv-advanced-airway-adjunct",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-airway-patency-technique-suction-airway",
        interventionID: "intv-airway-patency-technique-suction-airway",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-apply-sterile-dressings",
        interventionID: "intv-apply-sterile-dressings",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-back-blows-and-chest-thrusts",
        interventionID: "intv-back-blows-and-chest-thrusts",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-severe-bleeding-technique-direct-pressure",
        interventionID: "intv-control-severe-bleeding-technique-direct-pressure",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-severe-bleeding-technique-tourniquet",
        interventionID: "intv-control-severe-bleeding-technique-tourniquet",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-severe-bleeding-technique-2nd-tourniquet",
        interventionID: "intv-control-severe-bleeding-technique-2nd-tourniquet",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-severe-bleeding-technique-pack-wound-with-gauze",
        interventionID: "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-severe-bleeding-technique-pressure-bandage",
        interventionID: "intv-control-severe-bleeding-technique-pressure-bandage",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-severe-bleeding-technique-load-and-go",
        interventionID: "intv-control-severe-bleeding-technique-load-and-go",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-shock-technique-keep-patient-warm",
        interventionID: "intv-control-shock-technique-keep-patient-warm",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-shock-technique-administer-high-concentration-o2",
        interventionID: "intv-control-shock-technique-administer-high-concentration-o2",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-shock-technique-place-patient-supine-position",
        interventionID: "intv-control-shock-technique-place-patient-supine-position",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-control-shock-technique-administer-iv-boluses",
        interventionID: "intv-control-shock-technique-administer-iv-boluses",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-heimlich-maneuver",
        interventionID: "intv-heimlich-maneuver",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-keep-body-part-cool",
        interventionID: "intv-keep-body-part-cool",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-magill-forceps-assisted",
        interventionID: "intv-magill-forceps-assisted",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-manual-finger-sweep",
        interventionID: "intv-manual-finger-sweep",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-nasopharyngeal-airway",
        interventionID: "intv-nasopharyngeal-airway",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-nasotracheal-intubation",
        interventionID: "intv-nasotracheal-intubation",
        interventionID: "intv-nasotracheal-intubation",
        interventionID: "intv-nasotracheal-intubation",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-needle-cricothyrotomy",
        interventionID: "intv-needle-cricothyrotomy",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-occlusive-dressing",
        interventionID: "intv-occlusive-dressing",
        intvCategoryID: "intv-cat-manage-thoracic-trauma"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-open-airway-method-head-tilt",
        interventionID: "intv-open-airway-method-head-tilt",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-open-airway-method-modified-jaw-thrust",
        interventionID: "intv-open-airway-method-modified-jaw-thrust",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-oropharyngeal-airway",
        interventionID: "intv-oropharyngeal-airway",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-orotracheal-intubation",
        interventionID: "intv-orotracheal-intubation",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-place-body-part-in-bag",
        interventionID: "intv-place-body-part-in-bag",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-place-immobilized-patient-on-stretcher",
        interventionID: "intv-place-immobilized-patient-on-stretcher",
        intvCategoryID: "intv-cat-extrication-and-transport"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-pleural-decompression",
        interventionID: "intv-pleural-decompression",
        intvCategoryID: "intv-cat-manage-thoracic-trauma"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-prepare-and-administer-pain-nausea-vomiting-medications",
        interventionID: "intv-prepare-and-administer-pain-nausea-vomiting-medications",
        intvCategoryID: "intv-cat-manage-pain-nausea-vomiting"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-prepare-and-administer-sedative",
        interventionID: "intv-prepare-and-administer-sedative",
        intvCategoryID: "intv-cat-sedate-agitated-or-combatitive-patient"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-rapid-sequence-intubation",
        interventionID: "intv-rapid-sequence-intubation",
        interventionID: "intv-rapid-sequence-intubation",
        interventionID: "intv-rapid-sequence-intubation",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-retrieve-amputated-body-part",
        interventionID: "intv-retrieve-amputated-body-part",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-sedation-assisted-intubation",
        interventionID: "intv-sedation-assisted-intubation",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 4,
        "type": "intervention",
        "id": "menu-item-slat",
        interventionID: "intv-slat",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-spinal-immobilization-technique-attach-cid",
        interventionID: "intv-spinal-immobilization-technique-attach-cid",
        intvCategoryID: "intv-cat-spinal-motion-restriction"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-spinal-immobilization-technique-cervical-collar",
        interventionID: "intv-spinal-immobilization-technique-cervical-collar",
        intvCategoryID: "intv-cat-spinal-motion-restriction"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-spinal-immobilization-technique-manual-c-spine",
        interventionID: "intv-spinal-immobilization-technique-manual-c-spine",
        intvCategoryID: "intv-cat-manual-c-spine-stabilization"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-spinal-immobilization-technique-manual-c-spine2",
        interventionID: "intv-spinal-immobilization-technique-manual-c-spine",
        intvCategoryID: "intv-cat-spinal-motion-restriction"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-spinal-immobilization-technique-transfer-to-device",
        interventionID: "intv-spinal-immobilization-technique-transfer-to-device",
        intvCategoryID: "intv-cat-spinal-motion-restriction"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-splint-fractures",
        interventionID: "intv-splint-fractures",
        intvCategoryID: "intv-cat-circulation-management"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-splint-fractures2",
        interventionID: "intv-splint-fractures",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-sterile-dressing-soft-tissue",
        interventionID: "intv-sterile-dressing-soft-tissue",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-supplemental-oxygen-device-nasal-cannula",
        interventionID: "intv-supplemental-oxygen-device-nasal-cannula",
        intvCategoryID: "intv-cat-manage-oxygenation-and-ventilation"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-supplemental-oxygen-device-non-rebreather-mask",
        interventionID: "intv-supplemental-oxygen-device-non-rebreather-mask",
        intvCategoryID: "intv-cat-manage-oxygenation-and-ventilation"
    },
    {
        "depth": 3,
        "type": "intervention",
        "id": "menu-item-surgical-cricothyrotomy",
        interventionID: "intv-surgical-cricothyrotomy",
        intvCategoryID: "intv-cat-airway"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-transfers-patient-method-walk-patient",
        interventionID: "intv-transfers-patient-method-walk-patient",
        intvCategoryID: "intv-cat-extrication-and-transport"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-transfers-patient-method-place-directly-on-stretcher",
        interventionID: "intv-transfers-patient-method-place-directly-on-stretcher",
        intvCategoryID: "intv-cat-extrication-and-transport"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-transport",
        interventionID: "intv-transport",
        intvCategoryID: "intv-cat-extrication-and-transport"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-transport-body-part-to-receiving-facility",
        interventionID: "intv-transport-body-part-to-receiving-facility",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    },
    {
        "depth": 1,
        "type": "intervention",
        "id": "menu-item-ventilation-technique-bag-valve-mask",
        interventionID: "intv-ventilation-technique-bag-valve-mask",
        intvCategoryID: "intv-cat-manage-oxygenation-and-ventilation"
    },
    {
        "depth": 2,
        "type": "intervention",
        "id": "menu-item-wrap-body-part-in-saline-soaked-gauze",
        interventionID: "intv-wrap-body-part-in-saline-soaked-gauze",
        intvCategoryID: "intv-cat-manage-wounds-and-specific-injuries"
    }
]

export default INTV_MENU_ITEMS